import * as React from "react";

import { AppState,  store, Actions, IPageState, DisplayWindow } from '../../appredux';

import { connect } from 'react-redux';

import { Grid, withStyles, Theme, WithStyles, Fab, Typography, Paper } from '@material-ui/core';

import { WithTranslation, withTranslation } from 'react-i18next';

import DialogCopyToCart from '../dialog/CopyToCart';

import Zamowienia from "./Zamowienia";
import Szczegoly from "./Szczegoly";
import { VatTableRow, VatTableRowFromTo, FakturaVatService, OfferService, MenuService, OfferTableHead, AsortGrupyWiersz } from "../../api";
import { string } from "prop-types";
import CONFIG from "../../cfg/config";

export enum DisplayHistory {   
    Zamowienia,
    Szczegoly,
  }

interface MainProps extends WithStyles<typeof styles>, WithTranslation {
    page: IPageState,
    bCpyToCart: boolean;
}

interface MainState {
    width: number,
    displayHistory: DisplayHistory,

    serwisHotelTablica: VatTableRowFromTo[];
    serwisStatusTablica: VatTableRow[];

    serwisHotelIlosc: number;
    serwisStatusIlosc: number;

    paginacjaHotel: number [],
    paginacjaStatus: number [],

    status: VatTableRowFromTo;
    telefon: number;
    asortyment : AsortGrupyWiersz[];
    openCpyDialog: boolean;
    dokNr: string;
}

class Main extends React.Component<MainProps, MainState>  {

    constructor(props: MainProps) {
        super(props, {});
        let tel = 0
        let cookies = localStorage.getItem('cookies_zaakceptowane')
        if(cookies === "true"){
          let t = localStorage.getItem('numer_telefonu');
          if(t) {
            t = t.split(" ").join("")
            tel = Number(t)
          }
        }
        this.state = {
            width: window.innerWidth, 
            displayHistory: DisplayHistory.Zamowienia,

            serwisHotelTablica: [],
            serwisStatusTablica: [],
      
            serwisHotelIlosc: 0,
            serwisStatusIlosc: 0,
            
            paginacjaHotel: [0, 1, 10],
            paginacjaStatus: [0, 1, 10],

            status: new VatTableRowFromTo(),
            telefon: tel,
            asortyment: [],
            openCpyDialog: false,
            dokNr: "",
        }
    }

    setSerwisHotelTablica = (tab: VatTableRowFromTo[], tel: number) => {
        this.setState({serwisHotelTablica: tab, telefon: tel})
    }

    setSerwisStatusTablica = (tab: VatTableRow[]) => {
        this.setState({serwisStatusTablica: tab})
    }


    setSerwisHotelIlosc = (ilosc: number) => {
        this.setState({serwisHotelIlosc: ilosc})
    }

    setSerwisStatusIlosc = (ilosc: number) => {
        this.setState({serwisStatusIlosc: ilosc})
    }

    setPaginacjaHotel = (paginacja: number[]) => {
        this.setState({paginacjaHotel: paginacja})
    }

    setPaginacjaStatus = (paginacja: number[]) => {
        this.setState({paginacjaStatus: paginacja})
    }

    selectStatus = (status: any) => {
        this.setState({displayHistory: DisplayHistory.Szczegoly, status: status})
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateWindowWidth);
    }

    componentDidUpdate(){
        if(this.props.bCpyToCart){
            store.dispatch(Actions.pageState.cpyToCart(false));
            this.addToCartConfirmed(this.state.dokNr);
        }
    }

    updateWindowWidth = () => {
        this.setState({ ...this.state, width: window.innerWidth });
    }

    back = async () => {
        if(this.state.displayHistory === DisplayHistory.Zamowienia){ 
            store.dispatch(Actions.pageState.setDisplayWindow(DisplayWindow.Main))  
        }else {
            this.setState({displayHistory: DisplayHistory.Zamowienia})
        }
    }

    closeCpyToCartDialog = () => {
        this.setState({ openCpyDialog: false })
    };

    openCpyToCartDialog = () => {
        this.setState({ openCpyDialog: true })
    };

    addToCart = async (aDokNr: string) => {
        this.setState({ openCpyDialog: true, dokNr: aDokNr});
    }

    addToCartConfirmed = async (aDokNr: string) => {
        const [faktura, grupy] = await Promise.all(
            [
                FakturaVatService.getTableRows({
                    hotelId: CONFIG.hotelID,
                    dokNr: aDokNr
                }, {}),

                OfferService.getOfferTableHeads({
                     hotelId: CONFIG.hotelID, 
                     aOperatorId: 1 })
            ]);

        for(let i = 0; i < grupy.result.length; i++){
            this.findNAddItemsToCart(grupy.result[i], faktura.result, i, grupy.result.length);
        }  
    }

    findNAddItemsToCart = async (item: OfferTableHead, faktura: VatTableRow[], i: number, len: number) => {
        const asortymentRes = await MenuService.getAsort({ hotelId: CONFIG.hotelID, 
            aOperatorId: Number(sessionStorage.getItem("operator_id")), aGrupaId: item.grupa_id }, {})
      
          asortymentRes.result.forEach((aResultItem) => { this.state.asortyment.push(aResultItem); })
      
          if(i === len -1)
            this.addItemsToCart(faktura);
    }

    addItemsToCart = async(faktura: VatTableRow[]) => {
        let pozycja = 1;

        faktura.forEach((item) => {
          this.state.asortyment.forEach(asortItem => {
            if(asortItem.mag_id == Number(item.magId) && asortItem.asort_id == Number(item.asortId) && Number(item.dokLp) == pozycja){

              this.AddItem( new AsortGrupyWiersz({
                "grupa_id": asortItem.grupa_id,
                "grupa_lp": asortItem.grupa_lp,
                "mag_id": asortItem.mag_id, //item.magId,
                "asort_id": asortItem.asort_id, //item.asortId,
                "asort_nazwa": asortItem.asort_nazwa, //item.asortNazwa,
                "vat_stawka": asortItem.vat_stawka, //item.vatStawka,
                "kolejnosc": asortItem.kolejnosc
              }), asortItem.cena);
              pozycja++;

            }
          })
        })

        store.dispatch(Actions.pageState.setDisplayWindow(DisplayWindow.Main))
    }

    AddItem = async (item: AsortGrupyWiersz, price: string = '-1') => {
        let items = store.getState().pageState.basket;
      
        // if (item.asort_id < 0) return;
      
        // if (price === '-1') {
        //   price = item.cena
        // }
      
        // const basketItem: ResBasketItem = {
        //   grupa_id: item.grupa_id.toString(),
        //   grupa_lp: item.grupa_lp.toString(),
        //   stawka_vat: item.vat_stawka.toString(),
        //   mag_id: item.mag_id.toString(),
        //   asort_id: item.asort_id.toString(),
        //   asort_nazwa: item.asort_nazwa.toString(),
        //   cena: price,
        //   kolejnosc: item.kolejnosc.toString(),
        // };
      
        //items.push(basketItem);
        items.push(item);
        await store.dispatch(Actions.pageState.updateBasket(items));
      }

    render = () => {
        const { classes } = this.props;



        return (
                <Grid container spacing={3} justifyContent="space-evenly" className={classes.container} style={{ width: "100%"  }} >
                    {/* <Grid item xs={12} md={6} lg={5} style={this.state.width <= 600 ? { paddingTop: "0px" } : {}} >
                        <Paper className={classes.paper2} elevation={0} style={{ height: "57px" }}>
                            <Typography variant="h6" component="h2" color="primary" align="center" style={{ lineHeight: "57px", color: "#e65100" }}>
                                <b>{'vsc serwis 24'}</b>
                            </Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6} lg={5} >
                        <SerwisyMenu />
                    </Grid> */}
                    <Grid item style={{ width: "100%" }}>

                    {this.state.displayHistory === DisplayHistory.Zamowienia ?
                        <Zamowienia
                            width={this.state.width}

                            serwisHotelTablica={this.state.serwisHotelTablica}
                            setSerwisHotelTablica={this.setSerwisHotelTablica}

                            serwisHotelIlosc={this.state.serwisHotelIlosc}
                            setSerwisHotelIlosc={this.setSerwisHotelIlosc}

                            paginacjaHotel={this.state.paginacjaHotel}
                            setPaginacjaHotel={this.setPaginacjaHotel}

                            selectStatus={this.selectStatus}
                            addToCart={this.addToCart}
                            telefon={this.state.telefon} />
                    :
                    this.state.displayHistory === DisplayHistory.Szczegoly ?
                        <Szczegoly
                            width={this.state.width}
                            status={this.state.status}

                            serwisStatusTablica={this.state.serwisStatusTablica}
                            setSerwisStatusTablica={this.setSerwisStatusTablica}

                            serwisStatusIlosc={this.state.serwisStatusIlosc}
                            setSerwisStatusIlosc={this.setSerwisStatusIlosc}

                            paginacjaStatus={this.state.paginacjaStatus}
                            setPaginacjaStatus={this.setPaginacjaStatus} />
                    :
                    null
                    }

                    </Grid>

                    <Fab
                        color="primary"
                        aria-label="wróć"
                        onClick={this.back}
                        className={classes.fab}
                        style={{ height: "40px" }}
                    >
                        <Typography style={{ textTransform: "none", fontSize: "14px", color: "white" }}>
                            {"wróć"}
                        </Typography>
                    </Fab>

                    <DialogCopyToCart open={this.state.openCpyDialog} close={this.closeCpyToCartDialog} />
                </Grid>
        )

    }
}

const styles = (theme: Theme) => ({
    root: {
        margin: "0",
        minHeight: "96vh",
        //background: "./img/backgrounds/bg.png",
        fontSize: "12px",
        fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
        lineHeight: "20px",
        fontWeight: theme.typography.body2.fontWeight
    },
    //PM
    container: {
        margin: "0em auto",
        padding: '1em 5em',
        width: "100%",
        maxWidth: "1600px",
        "@media screen and (max-width: 600px)": {
            padding: '1em 0em',
        },
    },
    fab: {
        zIndex: 1000,
        position: "fixed" as "fixed",
        bottom: "15px",
        right: "15px"
    },
    marginAuto: {
        margin: 'auto'
    },
    paper2: {
        background: "linear-gradient(to bottom, #ffffff, #f7f7f7)",
        //padding: "16.9px 1px 11.9px ",
        width: "-webkit-fill-available"
    },
});

// połączenie z Redux
// wstrzykiwanie store.pageState do props.state
const mapStateToProps = (state: AppState) => ({
    page: state.pageState,
    bCpyToCart: state.pageState.bCpyToCart
});


//withStyles(styles)(Main))
export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(Main)));
